import { BusEvent } from '@web/common';

export class AdminPaymentMethodChangedBusEvent extends BusEvent {}
